import React from 'react';

import { Box } from '@mui/material';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

export const DevelopmentTools: React.FC = () => {
  return (
    <Box data-testid='development_tools'>
      <ReactQueryDevtools initialIsOpen={false} />
      <TanStackRouterDevtools initialIsOpen={false} />
    </Box>
  );
};
